// ----------------------------------------------------------------------------

function leftRotate(arr: any[], rotate: number, value?: number): any[] {
    let result = arr.splice(0);

    for (let i = 0; i < rotate; i++) {
        result = leftRotateByOne(result, value);
    }

    return result;
}

function leftRotateByOne(arr: any[], value?: number): any[] {
    const temp: any[] = [];

    let i: number;

    // If you do not use the number, it is the default for the array size
    value = value ?? arr.length;

    for (i = 0; i < value - 1; i++) {
        temp[i] = arr[i + 1];
    }

    temp[i] = arr[0];

    return temp;
}

// ----------------------------------------------------------------------------

export { leftRotate, leftRotateByOne };
